"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const contentSectionCss = core_1.css({
    display: 'flex',
    flexDirection: 'column',
    ':not(:last-of-type)': {
        marginBottom: theme_1.Spacing.extraLarge,
    },
});
const contentImageContainerCss = {
    alignItems: 'center',
    backgroundColor: design_system_1.Colors.grey100,
    border: `1px solid ${design_system_1.Colors.grey200}`,
    borderRadius: theme_1.Border.radius.large,
    display: 'flex',
    marginBottom: theme_1.Spacing.medium,
    minHeight: 200,
};
const contentImageCss = {
    borderRadius: theme_1.Border.radius.large,
};
const ContentSection = ({ title, content, imageUrl, date, }) => (common_utils_1.isolateComponent("div", { css: contentSectionCss },
    common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500", type: "altText800" }, date),
    common_utils_1.isolateComponent(design_system_1.Text, { type: "subtitle800" }, title),
    common_utils_1.isolateComponent("p", null,
        common_utils_1.isolateComponent(design_system_1.Text, { type: "bodyText800" },
            content,
            ' ',
            common_utils_1.isolateComponent(design_system_1.Link, { href: "https://zapier.com/blog/updates/2271/introducing-shareable-zaps", target: "_blank" }, "Learn more"))),
    imageUrl && (common_utils_1.isolateComponent("div", { css: contentImageContainerCss },
        common_utils_1.isolateComponent(common_components_1.StaticImage, { alt: "", css: contentImageCss, src: imageUrl })))));
const { medium, extraLarge } = theme_1.Spacing;
const headerPadding = `${medium}px ${medium}px ${medium}px ${extraLarge}px`;
const contentSectionContainerCss = core_1.css({
    maxHeight: '70vh',
    overflowY: 'scroll',
    padding: extraLarge,
});
const headerCss = {
    alignItems: 'center',
    borderBottom: `1px solid ${design_system_1.Colors.grey200}`,
    display: 'flex',
    padding: headerPadding,
};
const footerCss = {
    alignItems: 'center',
    borderTop: `1px solid ${design_system_1.Colors.grey200}`,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: headerPadding,
};
const EditorAnnouncementModal = ({ contents, onClose }) => (common_utils_1.isolateComponent(common_components_1.Modal, { onClose: onClose, overflowY: "hidden", padding: 0 },
    common_utils_1.isolateComponent("header", { css: headerCss },
        common_utils_1.isolateComponent(design_system_1.Heading, null,
            common_utils_1.isolateComponent(design_system_1.Text, { type: "subtitle900" }, "What's New on Zapier"))),
    common_utils_1.isolateComponent("div", { css: contentSectionContainerCss }, lodash_1.map(contents, (content, index) => (common_utils_1.isolateComponent(ContentSection, Object.assign({}, content, { key: index }))))),
    common_utils_1.isolateComponent("footer", { css: footerCss },
        common_utils_1.isolateComponent(design_system_1.Button, { onClick: onClose }, "Dismiss"))));
exports.default = EditorAnnouncementModal;
